export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadJSON<T>(data: T, filename: string): void {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  downloadBlob(blob, filename);
}

export function downloadZip(blob: Blob, filename: string): void {
  downloadBlob(blob, filename);
}


export function downloadCSV(
  headers: string[],
  rows: string[][],
  filename: string
): void {
  const escapeCSV = (value: string): string => {
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const headerRow = headers.map(escapeCSV).join(',');
  const dataRows = rows.map((row) => row.map(escapeCSV).join(','));
  const csv = [headerRow, ...dataRows].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, filename);
}

export async function downloadFromUrl(
  url: string,
  filename: string,
  headers?: Record<string, string>
): Promise<void> {
  const response = await fetch(url, { headers });

  if (!response.ok) {
    throw new Error(`Failed to download: ${response.statusText}`);
  }

  const blob = await response.blob();
  downloadBlob(blob, filename);
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function getFileExtension(filename: string): string {
  const lastDot = filename.lastIndexOf('.');
  return lastDot === -1 ? '' : filename.slice(lastDot + 1).toLowerCase();
}

export function generateDownloadFilename(
  prefix: string,
  extension: string
): string {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `${prefix}_${timestamp}.${extension}`;
}

/**
 * Extracts the token from a Pryv API URL.
 * @param apiUrl The full API URL containing the token
 * @returns The extracted token, or empty string if extraction fails
 */
export function extractTokenFromUrl(apiUrl: string | undefined): string {
  if (!apiUrl) return '';

  try {
    // Extract the part between "https://" and "@"
    const match = apiUrl.match(/https?:\/\/([^@]+)@/);
    return match?.[1] ?? '';
  } catch {
    return '';
  }
}
